<div id="{{file.src === 'placeholder' ? file.src : '' }}">
  <ng-container *ngIf="!isGalleryManager">
    <p>{{getFilename(file)}}</p>
    <span>{{getFileExtension(file)}} - download</span>
  </ng-container>
</div>
